import { t } from "i18next";
import PropTypes from "prop-types";
import React from "react";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

// Styled components (same as before)
const CustomToggle = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 5px; 
  font-size: 16px;
  cursor: pointer;
  color: #184A61;
  font-family: Lato;

  &::after {
    display: none !important;
  }
`;

const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  position: ${({ isPosition }) => (isPosition ? "" : "relative")};
  cursor: pointer;
  margin: ${({ margin }) => (margin ? margin : "0px")};
`;

const CustomToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CustomMenuV1 = styled(Dropdown.Menu)`
  border: 1px solid #EFEFEF !important;
  border-radius: 4px !important;
  min-width: 136px !important;
  padding: 0px !important;
  ${'' /* overflow-x: hidden !important; */}
  overflow-y: auto !important;
  position: absolute !important;
  top: ${({ isTop }) => (isTop ? `${isTop} !important` : "14px !important")};
  left: auto !important;
  right: ${({ isRight }) => (isRight ? `${isRight} !important` : "14px !important")};
  z-index: 1050 !important;
    /* Scrollbar styling */
    &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;  /* Change to your desired color */
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;  /* Optional darker shade on hover */
  }

  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #888 transparent; /* For Firefox */
`;

const CustomDropdownItemV1 = styled(Dropdown.Item)`
  font-family: "Lato" !important;
  font-size: 16px !important;
  padding: 14px 16px !important;
  border-radius: 4px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ active }) => (active ? "white" : "#184A61")} !important;
  background-color: ${({ active, bgColor }) => (active ? bgColor : "transparent")} !important;

  &:hover {
    border-radius: 4px !important;
    color: white !important;
    background-color: ${({ bgColor }) => (bgColor ? bgColor : "#088A96")} !important;
  }

  &:focus {
    outline: none;
    color: white !important;
    background-color: ${({ bgColor }) => (bgColor ? bgColor : "#088A96")} !important;
    border-radius: 4px !important;
  }

  > img {
    height: 32px !important;
    width: 32px !important;
  }
`;

// ReusableDropdown Component
const ReusableDropdown = ({
  selectedValue,
  onSelect,
  options = [],
  bgColor = "#088A96",
  isTop,
  isRight,
  margin,
  getIcon = null,
  // Dynamic key names
  labelKey = "label",
  valueKey = "value",
  conditionKey = "condition",
}) =>  (
  <DropdownWrapper margin={margin}>
    <Dropdown onSelect={onSelect} style={{ cursor: "pointer" }}>
      <Dropdown.Toggle as={CustomToggle}>
        <CustomToggleWrapper>
          {t(selectedValue)}
          {getIcon && <span className="dropdown-arrow">{getIcon()}</span>}
        </CustomToggleWrapper>
      </Dropdown.Toggle>

      <CustomMenuV1 align="end" isRight={isRight} isTop={isTop}>
        {options.map((item) => {
          let label, value, condition;

          if (typeof item === "string") {
            label = value = item;
            condition = true;
          } else {
            label = item[labelKey];
            value = item[valueKey];
            condition = item[conditionKey] !== false;
          }

          if (!condition) return null;

          return (
            <CustomDropdownItemV1
              key={value}
              eventKey={value}
              active={selectedValue === value}
              bgColor={bgColor}
            >
              {t(label)}
            </CustomDropdownItemV1>
          );
        })}
      </CustomMenuV1>
    </Dropdown>
  </DropdownWrapper>
);

ReusableDropdown.propTypes = {
  selectedValue:PropTypes.string,
  onSelect:PropTypes.func,
  options:PropTypes.any,
  bgColor:PropTypes.string,
  isTop:PropTypes.string,
  isRight:PropTypes.string,
  margin:PropTypes.string,
  getIcon:PropTypes.func,
  t:PropTypes.string,
  // Dynamic key names
  labelKey:PropTypes.string,
  valueKey:PropTypes.string,
  conditionKey :PropTypes.string
}

export default ReusableDropdown;
